import { useTranslation } from 'react-i18next'

interface ChannelChipsProps {
  channels: { id: string; name: string; channel_name: string }[]
  selected: string | null
  onSelect: (id: string) => void
}

export function ChannelChips({ channels, selected, onSelect }: ChannelChipsProps) {
  const { t } = useTranslation()
  return (
    <div>
      <label className="block text-xs font-medium text-neutral-600 dark:text-neutral-400 mb-1">
        {t('amazonListing.manual.selectChannel')}
      </label>
      <div className="flex flex-wrap gap-2">
        {channels.map((ch) => (
          <button key={ch.id} onClick={() => onSelect(ch.id)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              selected === ch.id
                ? 'bg-orange-500 text-white' : 'bg-neutral-200 dark:bg-neutral-700 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-300 dark:hover:bg-neutral-600'
            }`}>
            {ch.channel_name || ch.name}
          </button>
        ))}
      </div>
    </div>
  )
}
